<!-- New create/edit button -->
<div [ngClass]="{ 'has-edit-button': isEditMode }">
  <ng-container
    *ngIf="isEditMode"
    [brManageContentButton]="document"
    documentTemplateQuery="new-ContentBlocks-document"
    folderTemplateQuery="new-ContentBlocks-folder"
    parameter="document"
    [relative]="false"
    root=""
  >
  </ng-container>

  <!-- Render Content -->
  <ng-container *ngIf="document && content">
    <!-- Unless margin bottom is explicitly set default to xl -->
    <!-- we set id only if defined in component, otherwise no id -->
    <div
      [attr.id]="divId ? divId : null"
      class="content-blocks
      content-blocks--{{ backgroundColor }} spacing--{{
        contentBlocksMarginBottom
      }}"
      [class.debug-mode]="debugMode"
    >
      <!-- Render Blocks  -->
      <ng-container *ngIf="contentBlocks">
        <ng-container
          *ngFor="
            let contentBlock of contentBlocks;
            let i = index;
            last as isLast
          "
        >
          <div
            [id]="contentBlock.sectionId || ''"
            class="content-block content-block--{{
              contentBlock.background?.toLowerCase()
            }}"
            [edsSpacing]="determineSpacing(isLast, i)"
          >
            <div edsGrid>
              <div
                class="container"
                [class.container--wide]="hasContainerWide"
                [attr.data-analytics-track-impression]="
                  trackImpression ? 'true' : null
                "
              >
                <div
                  edsSpacing="{{ contentBlock | ftContentBlockMargin: isLast }}"
                >
                  <ng-container *ngIf="!contentBlock.itemsTwo; else twoCol">
                    <ft-one-col-block
                      [contentBlock]="contentBlock"
                      [page]="page"
                      [titleColorTheme]="titleColor"
                      [component]="component"
                    ></ft-one-col-block>
                  </ng-container>
                  <ng-template #twoCol>
                    <ft-two-col-block
                      [contentBlock]="contentBlock"
                      [page]="page"
                      [titleColorTheme]="titleColor"
                      [component]="component"
                    ></ft-two-col-block>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <!-- DEBUG PADDING -->
      <span
        *ngIf="debugMode && removeMarginBottom === 'true'"
        [ngStyle]="{
          background: 'red',
          color: 'white',
          position: 'absolute',
          bottom: 'top',
          display: 'block',
          padding: '1rem'
        }"
        >RMVD</span
      >
      <!-- / DEBUG PADDING -->
    </div>
  </ng-container>

  <!-- no document -->
  <div *ngIf="!document && isEditMode" class="no-document">
    <div edsGrid class="no-document__component">
      <div class="no-document__overlay">
        Click to configure <strong>Content Blocks</strong>
      </div>
    </div>
  </div>
</div>
